<div class="event-create">
  <rappider-crud-view-edit-form [config]="WORKFLOW_EVENT_CREATE_CONFIG"
                                [submitButtonLoading]="submitButtonLoading"
                                (fieldValueChange)="onFieldValueChange($event)"
                                (formSubmit)="onCreateWorkflowEventFormSubmit($event)"></rappider-crud-view-edit-form>
</div>
